var _rect, _path, _path2, _g, _g2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#339DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6708 25.9653C47.6303 22.5648 46.735 15.0295 46.735 15.0295C46.735 15.0295 39.4214 13.0065 35.4619 16.4071L18.7351 30.7726L26.9439 40.3308L43.6708 25.9653Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.97747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9663 41.9142C19.2293 43.406 14.2502 43.1308 14.2502 43.1308C14.2502 43.1308 14.9812 38.4577 16.7163 36.9675C18.4515 35.4773 20.0223 37.0551 20.6963 37.8469C21.3703 38.6388 22.7015 40.4224 20.9663 41.9142Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7431 33.4196C35.6269 35.9312 35.2441 38.4234 34.6013 40.8542C33.9602 42.0974 33.0903 43.2084 32.0373 44.1291L27.6352 47.9037C27.5067 48.0146 27.3469 48.0827 27.1779 48.0984C27.0089 48.1142 26.8392 48.0768 26.6925 47.9915C26.5458 47.9062 26.4294 47.7772 26.3595 47.6226C26.2896 47.4679 26.2697 47.2953 26.3026 47.1288L27.6131 40.4003",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7431 33.4196C35.6269 35.9312 35.2441 38.4234 34.6013 40.8542C33.9602 42.0974 33.0903 43.2084 32.0373 44.1291L27.6352 47.9037C27.5067 48.0146 27.3469 48.0827 27.1779 48.0984C27.0089 48.1142 26.8392 48.0768 26.6925 47.9915C26.5458 47.9062 26.4294 47.7772 26.3595 47.6226C26.2896 47.4679 26.2697 47.2953 26.3026 47.1288L27.6131 40.4003",
    stroke: "white",
    strokeWidth: 1.97747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1811 23.0828C24.6705 22.7985 22.1367 22.782 19.6226 23.0336C18.3085 23.4989 17.0941 24.2083 16.0433 25.1244L11.653 28.8934C11.524 29.004 11.4329 29.1521 11.3922 29.317C11.3515 29.482 11.3634 29.6555 11.4261 29.8134C11.4889 29.9712 11.5994 30.1055 11.7422 30.1975C11.885 30.2895 12.053 30.3346 12.2227 30.3265L19.1141 30.0094",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1811 23.0828C24.6705 22.7985 22.1367 22.782 19.6226 23.0336C18.3085 23.4989 17.0941 24.2083 16.0433 25.1244L11.653 28.8934C11.524 29.004 11.4329 29.1521 11.3922 29.317C11.3515 29.482 11.3634 29.6555 11.4261 29.8134C11.4889 29.9712 11.5994 30.1055 11.7422 30.1975C11.885 30.2895 12.053 30.3346 12.2227 30.3265L19.1141 30.0094",
    stroke: "white",
    strokeWidth: 1.97747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4837,
    cy: 21.4391,
    r: 2.58936,
    transform: "rotate(4.34312 39.4837 21.4391)",
    fill: "white",
    stroke: "#339DFF",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/get-started.2711242f16ec130e8d5c6a921865f7cd.svg";
export { ForwardRef as ReactComponent };